import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/home.css";

const API_URL = "https://ecommerce-backend-zxtw.onrender.com";

const PaymentCallback = () => {
  const [message, setMessage] = useState("Processing payment...");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const razorpay_payment_id = searchParams.get("razorpay_payment_id");
    const razorpay_order_id = searchParams.get("razorpay_order_id");
    const razorpay_signature = searchParams.get("razorpay_signature");
    const orderData = localStorage.getItem("orderData");

    if (!razorpay_payment_id || !orderData) {
      setMessage("Payment data missing. Please contact support.");
      return;
    }

    const payload = {
      ...JSON.parse(orderData),
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature
    };

    fetch(`${API_URL}/api/payment/verify-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          localStorage.removeItem("orderData");
          setMessage("Payment successful! Redirecting...");
          setTimeout(() => navigate("/order-success", {
            state: {
              total: payload.total,
              paymentId: payload.razorpay_payment_id
            }
          }), 1000);
        } else {
          setMessage("Payment verification failed. Please contact support.");
        }
      })
      .catch(err => {
        console.error(err);
        setMessage("Error processing payment. Please contact support.");
      });
  }, [searchParams, navigate]);

  return (
    <>
      <Navbar />
      <div className="success-container">
        <div className="success-card">
          <h1>Processing Payment</h1>
          <p>{message}</p>
        </div>
      </div>
      <BottomNav />
    </>
  );
};

export default PaymentCallback;